export const environment = {
  appTitle: "QEmpower",
  appVersion: "1.5.1",
  name: 'local',
  production: false,
  applicationUrl: "http://localhost:4200",
  supabaseUrl: "http://localhost:54321",
  supabaseProjectId: "localhost",
  supabaseKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0",
  supabaseEdgeFunctionEndpoint: 'http://127.0.0.1:54321/functions/v1',
  authEmail: "@no-reply.qundis-tool.com",
  editorAiPluginLabel: "QundisGPT",
  editorAiPluginEndpoint: "http://localhost/Chat",
  deletedSystemUserUuid: "5612189b-7db0-48ae-8810-187c95c3b207"
};
